<template>
  <div>
    <div class="login">
      <h2 class="uk-text-lead">Member Login</h2>
      <p v-if="error">Invalid Book Number</p>
      <form @submit.prevent="handleSubmit">
        <label for="#bookNum">Book Number</label>
        <input class="uk-input" type="text" id="bookNum" v-model="bookNum">
        <input class="uk-button uk-button-primary" type="submit" name="" id="" value="Submit">
      </form>
      <p>Only Union Members currently on the Referral List will be able to access the information on this site. Please contact the Union Hall at (215) 462-7300 for assistance.</p>
    </div>
    <vk-button type="link" class="uk-align-center" v-on:click="$router.push('/login')">Administrator Login &#187;</vk-button>
  </div>
</template>

<script>
import MembersApi from "@/utils/api/members";

export default {
  name: "MemberLogin",
  data() {
    return {
      bookNum: "",
      error: false
    };
  },
  methods: {
    handleSubmit() {
      MembersApi.validateBookNum(this.bookNum)
        .then(valid => {
          if (valid) {
            this.$router.push({
              path: "queue",
              query: { bookNum: this.bookNum }
            });
          } else {
            this.error = true;
          }
        })
        .catch(error => console.log(error))
        .finally(() => {});
    }
  }
};
</script>

<style scoped>
h2 {
  font-weight: bold;
  margin: 10px 0px;
}
.login {
  max-width: 400px;
  background-color: #eeeeee;
  border: 0px solid #999999;
  padding: 15px;
  margin: 0 auto;
  text-align: left;
}
.uk-button {
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/member_login.vue